import React from 'react';
import { BreadCrumb } from '../components';
import CIFaq from '../components/CovidInsuranceFaq';
import '../../styles/BannerCI.css';
import '../../styles/baseCI.css';
import '../../styles/FaqCI.css';
import '../../styles/HeaderCI.css';
import '../../styles/InsuranceCI.css';
import '../../styles/markdownCI.css';
import '../../styles/tripMoneySpritesCI.css';
import PropTypes from 'prop-types';
import HtmlHeader from '../components/HtmlHeader';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';

const StaticCovidInsurancePage = ({ data }) => {
  return (
    <>
      <div className="containerCI .dark-text ">
        <HtmlHeader data={data} />
        <BreadCrumb breadcrumb={data.template.breadcrumb} visible={false} />
        <h1 className={'hidden'}>Corona Health Insurance Policy</h1>

        <div
          style={{
            color: '#032134',
            backgroundColor: '#fff',
            fontFamily: "'Poppins', sans-serif"
          }}
          id="app"
        >
          <div className="tm__header">
            <div className="tm__main tm__header__inner">
              <a
                onClick={() => {
                  window.open('http://www.tripmoney.com', '_self');
                }}
                className="tm__sprite tm__logo--black appendLeft10"
              >
                {' '}
                &nbsp;
              </a>
            </div>
          </div>

          <div className="ins__main">
            <div className="ins__banner">
              <div className="banner__info whiteText">
                <p className="banner__title">
                  Get your
                  <br />
                  insurance cover
                </p>
                <p className="positive__text">on testing positive for COVID-19</p>

                <div className="appDownloadSmall">
                  <p style={{ fontSize: '12px', marginBottom: '10px' }}>
                    Click here to download app
                    <br /> and buy policy
                  </p>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    style={{ marginRight: '20px' }}
                    href="https://app.mmyt.co/Xm2V/m6k154xt"
                  >
                    <img src="https://promos.makemytrip.com/images/googlePlay.png" alt="" />
                  </a>
                  <a target="_blank" rel="noreferrer" href="https://app.mmyt.co/Xm2V/mk8j4lzz">
                    <img src="https://promos.makemytrip.com/images/appStore.png" alt="" />
                  </a>
                </div>
              </div>
              <span className="digit__img tm__sprite pushRight"></span>
            </div>

            <div className="ftr__step__wrap">
              <div className="policy__ftr">
                <p className="ftr__step__title bold">Policy Features</p>
                <ul>
                  <li>
                    <span className="ftr__icon__wrap">
                      <span className="">
                        <span className="tm_medical_tests_img"></span>
                      </span>
                    </span>
                    Medical tests – Not required
                  </li>
                  <li>
                    <span className="ftr__icon__wrap">
                      <span>
                        <span className="tm_icu_img"></span>
                      </span>
                    </span>
                    Room rent/ ICU limit – No restriction
                  </li>
                  <li>
                    <span className="ftr__icon__wrap">
                      <span className="tm__sprite hospital__icon"></span>
                    </span>
                    Hospitals covered – All (Private, Govt, Army) approved by Govt. for COVID-19
                  </li>
                  <li>
                    <span className="ftr__icon__wrap">
                      <span className="tm__sprite days__icon"></span>
                    </span>
                    30 days pre and 60 days post hospitalization covered
                  </li>
                  <li>
                    <span className="ftr__icon__wrap">
                      <span>
                        <span className="tm_policy_duration_img"></span>
                      </span>
                    </span>
                    Policy duration - 365 days
                  </li>
                </ul>
              </div>

              <span className="divider__line"></span>

              <div className="simple__steps__wrap">
                <p className="simple__step__title bold">In just 3 simple steps</p>
                <ul className="simple__steps">
                  <li>
                    Choose
                    <br />
                    Option
                  </li>
                  <li>
                    Fill holder
                    <br />
                    details
                  </li>
                  <li>
                    Pay &<br />
                    Activate
                  </li>
                </ul>
              </div>
            </div>

            <div className="btn__outer">
              <div className="appDownloadBig" style={{ fontSize: '18.72px', textAlign: 'center' }}>
                <h3>Click here to download app and buy policy</h3>
                <a
                  target="_blank"
                  rel="noreferrer"
                  style={{ marginRight: '20px' }}
                  href="https://app.mmyt.co/Xm2V/m6k154xt"
                >
                  <img src="https://promos.makemytrip.com/images/googlePlay.png" alt="" />
                </a>
                <a target="_blank" rel="noreferrer" href="https://app.mmyt.co/Xm2V/mk8j4lzz">
                  <img src="https://promos.makemytrip.com/images/appStore.png" alt="" />
                </a>
              </div>
            </div>

            <p className="powered__digit appendBottom30">Powered by Digit</p>
          </div>
          <CIFaq data={data.faq} pageUrl={data.template.sample_url} />
        </div>
      </div>
    </>
  );
};

StaticCovidInsurancePage.propTypes = {
  data: PropTypes.object
};

StaticCovidInsurancePage.fetchData = () => {
  const template = {
    meta_data: {
      title: `Corona Health Insurance Policy for Family | Covid 19 Family Insurance Plan`,
      meta: [
        {
          charset: 'UTF-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0, shrink-to-fit=no'
        },
        {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=utf-8'
        }
      ],
      link: [
        {
          rel: 'icon',
          href: `https://www.tripmoney.com/ext/static/favicon-96x96.png`
        }
      ],
      script: [],
      noscript: []
    },
    template_name: `covid-insurance`,
    pageUrl: `https://www.makemytrip.com/railways/corona-virus-insurance-policy.html`,
    meta_title: `Corona Health Insurance Policy for Family | Covid 19 Family Insurance Plan`,
    meta_description: `Buy Corona Health Insurance Policy Online Covering upto 3 Lakh for Family. Covid Insurance Policy Covering Hospitalization Medical Expenses with Instant Digital Activation & No Medical Tests Required.`,
    meta_keywords: `corona virus insurance, affordable corona virus health insurance, covid health insurance, covid 19 health insurance, covid safe health policy, corona insurance policy, corona med claim, corona treatment, corona medicine, corona medical help, coronil for corona, cure for corona`,
    analytics: getStaticPageLoadEvent('seo:rails:corona insurance'),
    footer_data: ``,
    h1_title: `Corona Health Insurance Policy`,
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.tripmoney.com/`,
        displayString: `Landing`
      },
      {
        displayString: `Corona Health Insurance Policy`,
        redirectionUrl: `https://www.makemytrip.com/railways/corona-virus-insurance-policy.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/corona-virus-insurance-policy.html`,
    // eslint-disable-next-line
    external_js: ``,
    extra_info: ``
  };
  const faq = [
    {
      question: `What is Digit Group Illness Insurance?`,
      answer: `Digit Group Illness Insurance is an
            indemnity product, covering your hospitalization expenses incurred due positive diagnosis of
            Coronavirus disease (COVID-19). Anyone between the age group of 18 to 60 years is eligible
            to buy the coronavirus (COVID-19) cover (you can also cover anyone in your family up to the
        age of 60 years)`
    },
    {
      question: `What is the maximum Sum Insured that I can opt for under this policy?`,
      answer: `This policy has individual Sum Insured
            options up to INR 3 Lakhs which means that each individual policy can have a maximum Sum
        Insured of INR 3 Lakhs.`
    },
    {
      question: `When can I make a claim?`,
      answer: `You can make a claim if you are diagnosed
            and tested positive for COVID-19 and hospitalized solely due to COVID-19.`
    },
    {
      question: `Is this a Floater or Individual Policy?`,
      answer: `This is an Individual Sum Insured policy.`
    },
    {
      question: `Is it mandatory to have inpatient treatment at a hospital, for a claim to be admitted
            under the policy?`,
      answer: `Yes, the policy is for inpatient treatment
            in any hospital (Government, Private – government authorized, Military)`
    },
    {
      question: `If I get quarantined, will my policy cover the Hospitalization expenses incurred?`,
      answer: `Yes. Coverage for Quarantine in a hospital
            shall be payable only if it is later diagnosed that the insured person was suffering from
        COVID-19 during the Quarantine.`
    },
    {
      question: `Is there any waiting period applicable in this policy?`,
      answer: `Yes. The Digit Group Illness Insurance has
            an initial waiting period of 15 days and shall be applicable for anyone who avails of this
        policy.`
    },
    {
      question: `What are the other important exclusions in the policy that I should be aware of?`,
      answer: `<p>Exclusions under the Digit Group Illness Insurance plan include:   </p>
            <ul style="list-style-type: circle">
                <li>Hospitalisation expenses in case of texting negative Coronavirus disease (COVID-19)    </li>
                <li>Charges towards treatment or quarantine for Coronavirus disease (COVID-19) before the policy issuance will not be covered   </li>
                <li><strong>Comorbidity exclusion clause -</strong> Insured Member(s) is/are not suffering from fever or suffering /suffered from diabetes, hypertension, disease related to heart/lungs/kidney/liver, cancer, stroke or any condition that needs ongoing medication or the insured members(s) is/are due for any medical treatment, at the time of buying this policy   </li>
                <li>Home hospitalisation (Domiciliary hospitalisation) expenses will not be covered   </li>
                <li>Hospitalisation expenses for patients only under investigation with inconclusive medical report will not be covered   </li>
                <li>Treatment taken outside India will not be covered   </li>
                <li>Test report for Coronavirus disease (COVID-19) conducted from centres other than Govt/ICMR Authorized test Centre in India will not be considered</li>
            </ul>`
    },
    {
      question: `What is the process to reimburse already incurred expenses?`,
      answer: `<p>Below steps to reimburse:   </p>
            <ul style="list-style-type: circle">
                <li><strong>Intimation-</strong> Insured to call digit to register reimbursement claim   </li>
                <li><strong>Document Upload-</strong>  Insured to upload all relevant documents on digit website or email them to <a href="mailto:healtclaims@godigit.com">healtclaims@godigit.com</a>   </li>
                <li><strong>Settlement-</strong> Digit will verify the document and process the claim within 3 days. The amount will be transferred to the insured's bank account.</li>
            </ul>`
    },
    {
      question: `Is it cashless? What is the process?`,
      answer: `<p> Yes.The process is as below:   </p >
        <ul style="list-style-type: circle">
            <li><strong>Intimation-</strong> Insured informs Digit about the hospital details and shares the report from ICMR authorised about being corona +ve . Report to be emailed to <a href="mailto:healthclaims@godigit.com">healthclaims@godigit.com</a> .   </li>
            <li><strong>Approval-</strong>  If eligible digit will inform the hospital for cashless approval   </li>
            <li><strong>Settlement-</strong> Amount will be settled with the hospital directly</li>
        </ul>`
    }
  ];

  const finalResponse = {
    faq,
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_CORONA-VIRUS-INSURANCE-POLICY.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default StaticCovidInsurancePage;
